export default (payload) => ({
  type: 'NEW_LEAD_STATE',
  payload,
});
